import { render, staticRenderFns } from "./Tested.vue?vue&type=template&id=258952a0"
import script from "./Tested.vue?vue&type=script&lang=js"
export * from "./Tested.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports